export enum CodewordTypeEnum {
  MOTHERS_MAIDEN_NAME = 'MOTHERS_MAIDEN_NAME',
}
